import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Wrapper } from '../ui/Wrapper/Wrapper';
import ReactPlayer from 'react-player';
import { getLocalImage } from '../../helpers/getLocalImages';

const animationCircle = keyframes`
    100% {
        transform: rotate(360deg);
    }
`;

const animationSoundBar = keyframes`
    0% {
        transform: scaleY(1);
        opacity: .1;
    }
    100% {
        transform: scaleY(4);
        opacity: 1;
    }
`;

const animationCircPlay = keyframes`
    0% {
        border-radius: 60px;
    }
    25% {
        border-radius: 20px;
    }
    50% {
        border-radius: 30px;
    }
    75% {
        border-radius: 25px;
    }
    100% {
        transform: rotate(360deg);
    }
`;

const WrapperBoxVideo = styled(Wrapper)`
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const BoxVideo = styled(Wrapper)`
    width: 100%;
    height: 88vh;
    overflow: hidden;
    .yq-player {
        display: flex;
        align-items: center;
        justify-content: center;
        video {
            width: auto!important;
            height: auto!important;
            min-width: 100%;
            min-height: 100%;
        }
    }
    @media ${({theme}) => theme.mediaQueries.breakpointMd} {
        height: 98vh;
        video {
            min-width: 120%!important;
        }
    }
`;

const WrapperButtonPlay = styled(Wrapper)`
    width: 60px;
    height: 60px;
    position: absolute;
    bottom: 5vh;
    right: 8%;
    user-select: none;

    @media ${({theme}) => theme.mediaQueries.breakpointMd} {
        bottom: 10vh;
    }

    &:after, &::after, &:before, &::before {
        content: '';
        width: 100%;
        padding-top: 100%;
        position: absolute;
        border-radius: 100%;
        animation: ${animationCircPlay} linear infinite;
    }
    &:after, &::after {
        animation-duration: 3s;
        border: 1px solid ${({theme}) => theme.colors.secondary};
    }
    &:before, &::before {
        animation-delay: 1.5s;
        animation-duration: 3s;
        border: 1px solid ${({theme}) => theme.colors.link};
    }

    img {
        max-width: 15px;
    }
`;

const WrapperSoundBar = styled(Wrapper)`
    width: 40px;
    padding-top: 15px;
    position: absolute;
    bottom: 8vh;
    right: 13%;
    cursor: pointer;
    @media ${({theme}) => theme.mediaQueries.breakpointMd} {
        bottom: 30vh;
        right: 8%;
    }
    ul {
        padding: 0px;
        margin: 0;
        list-style-type: none;
        li {
            width: 4px;
            height: 3px;
            margin-right: 3px;
            background: #fff;
            float: left;
            animation: ${animationSoundBar} 400ms ease-in-out infinite alternate;
            transform-origin: bottom;
            animation-play-state: running;
            &:nth-child(1) { animation-duration: 250ms }
            &:nth-child(2) { animation-duration: 300ms }
            &:nth-child(3) { animation-duration: 350ms }
            &:nth-child(4) { animation-duration: 400ms }
            &:last-child{
                margin-right: 0px;
            }
            &.mute { animation-play-state: paused }
        }
    }
`;

const WrapperCircle = styled(Wrapper)`
    position: absolute;
    left: 8%;
    bottom: 14vh;
    max-width: 120px;
    cursor: pointer;
    .circ {
        animation: 6s ${animationCircle} linear infinite;
    }
    img {
        max-width: 120px;
        position: absolute;
        user-select: none;
        &:last-child {
            max-width: 40px;
        }
    }
    @media ${({theme}) => theme.mediaQueries.breakpointMd} {
        left: 20%;
    }
`;

const Hero = () => {

    const [videoMute, setvideoMute] = useState(false);
    const [videoPlay, setvideoPlay] = useState(false);
    
    return (
            <WrapperBoxVideo position='relative'>
                {renderVideo()}
                {renderCircleimageScroll()}
                {renderSoundBar()}
                {renderButtonPlayVideo()}
            </WrapperBoxVideo>
    );

    function renderVideo() {
        return (
            <BoxVideo>
                <ReactPlayer
                    className='yq-player'
                    url={getLocalImage(window.innerWidth < 768 ? 'intro-mob.mp4' : 'Intro.mp4')}
                    playing={videoPlay}
                    loop
                    muted={videoMute}
                    width='100%'
                    height='100%'
                />
            </BoxVideo>
        )
    }

    function renderCircleimageScroll(){
        return (
            <WrapperCircle flex align='center' justify='center' onClick={() => handleScroll()}>
                <img className='circ' src={getLocalImage('circle.svg')} alt="circle" />
                <img src={getLocalImage('coffee.png')} alt="circle" />
            </WrapperCircle>
        );
    }

    function renderSoundBar(){
        return (
            <WrapperSoundBar onClick={() => setvideoMute(!videoMute)}>
                <ul>
                    {[0,1,2,3].map(x => <li key={x} className={videoMute ? 'mute' : ''}></li>)}
                </ul>
            </WrapperSoundBar>
        )
    }

    function renderButtonPlayVideo(){
        return (
            <WrapperButtonPlay flex align='center' justify='center' onClick={() => setvideoPlay(!videoPlay)}>
                <img src={getLocalImage(videoPlay ? 'pause.svg' : 'play.svg')} alt="button play video" />
            </WrapperButtonPlay>
        )
    }

    function handleScroll(){
        return window.scrollTo({top: (window.innerHeight / 2), behavior: 'smooth'});
    }
}
export default Hero;
